<template>
  <div class="register absolute">
    <div class="shading">
      <div class="pictrue acea-row row-center-wrapper">
        <img :src="logoUrl" v-if="logoUrl" />
        <img src="@assets/images/logo2.png" v-else />
      </div>
      <h2 class="logoTitle">名品mall</h2>
    </div>

    <div class="whiteBg">
      <div class="title">注册账号</div>
      <div class="list">
        <div class="item">
          <div>
            <svg class="icon" aria-hidden="true">
              <use xlink:href="#icon-phone_"></use>
            </svg>
            <input type="text" placeholder="输入手机号码" v-model="account" />
          </div>
        </div>
        <div class="item">
          <div class="align-left">
            <svg class="icon" aria-hidden="true">
              <use xlink:href="#icon-code_1"></use>
            </svg>
            <input
              type="text"
              placeholder="填写验证码"
              class="codeIput"
              v-model="captcha"
            />
            <button
              class="code"
              :disabled="disabled"
              :class="disabled === true ? 'on' : ''"
              @click="code"
            >
              {{ text }}
            </button>
          </div>
        </div>
        <div class="item">
          <div>
            <svg class="icon" aria-hidden="true">
              <use xlink:href="#icon-code_"></use>
            </svg>
            <input
              type="password"
              placeholder="填写您的登录密码"
              v-model="password"
            />
          </div>
        </div>
        <div class="item" v-if="isShowCode">
          <div class="align-left">
            <svg class="icon" aria-hidden="true">
              <use xlink:href="#icon-code_"></use>
            </svg>
            <input
              type="text"
              placeholder="填写验证码"
              class="codeIput"
              v-model="codeVal"
            />
            <div class="code" @click="again"><img :src="codeUrl" /></div>
          </div>
        </div>
      </div>
      <div class="logon" v-if="agreement" @click="register">注册</div>
      <div class="logon noagreement" v-else>注册</div>
      <br />
      <div class="tip">
        <a href="https://admin.hdmingpinmall.com/api/appUpdate"><span class="font-color-red">APP下载</span></a>
      </div>
      <!-- <div class="tip">
        <a href="https://admin.hdmingpinmall.com/api/appUpdate"><span class="font-color-red">安卓端下载</span></a>
        |
        <a href="https://admin.hdmingpinmall.com/api/appUpdate"><span class="font-color-red">苹果端下载</span></a>
      </div> -->
    </div>
    <div class="v"> <a href="https://beian.miit.gov.cn">{{ v }}</a></div>
  </div>
</template>
<script>
import Vue from "vue";
import { Popup } from "vant";
import { Checkbox } from "vant";
Vue.use(Popup);
Vue.use(Checkbox);
import PopupWin from "@/components/PopupWin";
import sendVerifyCode from "@mixins/SendVerifyCode";
import {
  login,
  loginMobile,
  registerVerify,
  register,
  getCodeApi
} from "@api/user";
import attrs, { required, alpha_num, chs_phone } from "@utils/validate";
import { validatorDefaultCatch } from "@utils/dialog";
import { getLogo } from "@api/public";
import cookie from "@utils/store/cookie";
import { VUE_APP_API_URL,VUE_APP_VERSION } from "@utils";
const BACK_URL = "login_back_url";

export default {
  name: "Login",
  mixins: [sendVerifyCode],
  components: [PopupWin],
  data() {
    return {
      v: '沪ICP备20008395号',
      agreement: true,
      show: false,

      account: "",
      password: "",
      captcha: "",
      type: "login",
      logoUrl: "",
      keyCode: "",
      codeUrl: "",
      codeVal: "",
      isShowCode: false
    };
  },
  mounted: function() {
    // this.getCode();
    // this.getLogoImage();
  },
  methods: {
    showWin(url) {
      var pos = VUE_APP_API_URL.lastIndexOf("/");
      var s = VUE_APP_API_URL.substring(0, pos);
      console.log(s);
      this.url = s + url;
      this.show = true;
    },
    again() {
      this.codeUrl =
        VUE_APP_API_URL +
        "/sms_captcha?" +
        "key=" +
        this.keyCode +
        Date.parse(new Date());
    },
    getCode() {
      getCodeApi()
        .then(res => {
          this.keyCode = res.data.key;
        })
        .catch(res => {
          this.$dialog.error(res.msg);
        });
    },
    async getLogoImage() {
      let that = this;
      getLogo(2).then(res => {
        that.logoUrl = res.data.logo_url;
      });
    },
    async loginMobile() {
      var that = this;
      const { account, captcha } = that;
      try {
        await that
          .$validator({
            account: [
              required(required.message("手机号码")),
              chs_phone(chs_phone.message())
            ],
            captcha: [
              required(required.message("验证码")),
              alpha_num(alpha_num.message("验证码"))
            ]
          })
          .validate({ account, captcha });
      } catch (e) {
        return validatorDefaultCatch(e);
      }
      loginMobile({
        phone: that.account,
        captcha: that.captcha,
        spread: cookie.get("spread")
      })
        .then(res => {
          let data = res.data;
          let expires_time = data.expires_time.substring(0, 19);
          expires_time = expires_time.replace(/-/g, "/");
          expires_time = new Date(expires_time).getTime() - 28800000;
          const datas = {
            token: data.token,
            expires_time: expires_time
          };
          that.$store.commit("LOGIN", datas);
          localStorage.setItem("account", that.account);

          if (!data.real_name) {
            this.$router.replace({ path: "/user/real" });
          } else {
            const backUrl = cookie.get(BACK_URL) || "/";
            cookie.remove(BACK_URL);
            this.$router.replace({ path: backUrl });
          }
        })
        .catch(res => {
          that.$dialog.error(res.msg);
        });
    },
    async register() {
      var that = this;
      const { account, captcha, password } = that;
      try {
        await that
          .$validator({
            account: [
              required(required.message("手机号码")),
              chs_phone(chs_phone.message())
            ],
            captcha: [
              required(required.message("验证码")),
              alpha_num(alpha_num.message("验证码"))
            ],
            password: [
              required(required.message("密码")),
              attrs.range([6, 16], attrs.range.message("密码")),
              alpha_num(alpha_num.message("密码"))
            ]
          })
          .validate({ account, captcha, password });
      } catch (e) {
        return validatorDefaultCatch(e);
      }
      register({
        account: that.account,
        captcha: that.captcha,
        password: that.password,
        spread: that.$route.params.uid
        // spread: cookie.get("spread")
      })
        .then(res => {
          that.$dialog.success(res.msg);
          //   that.formItem = 1;
        })
        .catch(res => {
          that.$dialog.error(res.msg);
        });
    },
    async code() {
      var that = this;
      const { account } = that;
      try {
        await that
          .$validator({
            account: [
              required(required.message("手机号码")),
              chs_phone(chs_phone.message())
            ]
          })
          .validate({ account });
      } catch (e) {
        return validatorDefaultCatch(e);
      }
      that.type = "register";
      await registerVerify({
        phone: that.account,
        type: that.type,
        key: that.keyCode,
        code: that.codeVal
      })
        .then(res => {
          that.$dialog.success(res.msg);
          that.sendCode();
        })
        .catch(res => {
          if (res.data.status === 402) {
            that.codeUrl = `${VUE_APP_API_URL}/sms_captcha?key=${that.keyCode}`;
            that.isShowCode = true;
          }
          that.$dialog.error(res.msg);
        });
    },

  }
};
</script>
<style scoped>
.code img {
  width: 100%;
  height: 100%;
}
.register .whiteBg .logon.noagreement {
  background: #a2a2a2;
}
.register .shading {
  height: auto;
}
.logoTitle {
  text-align: center;
  color: white;
  font-size: 0.5rem;
  margin: 0.3rem;
  margin-top: 0.1rem;
}
.v {
  text-align: center;
  margin-top: 1rem;
  color: #ffffff;
  /* display: none; */
}
.v a{
    color: #ffffff;
}
</style>
